'use client'

import posthog from 'posthog-js'

type CaptureProps = Record<string, string | boolean | undefined | null>

/**
 * Capture a PostHog event. Only in browser; no-op if PostHog not initialized.
 * Use POSTHOG_EVENTS and POSTHOG_SOURCE from posthog-events.ts.
 */
export function capturePostHogEvent(event: string, props?: CaptureProps) {
  if (typeof window === 'undefined') return
  try {
    const clean = props
      ? Object.fromEntries(
          Object.entries(props).filter(
            ([, v]) => v !== undefined && v !== null && v !== ''
          )
        ) as Record<string, string | boolean>
      : undefined
    posthog.capture(event, clean)
  } catch {
    // no-op
  }
}
